import firebase from "../../firebase/firebase";
import { DB_COLLECTIONS } from "../../firebase/collections";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
/**
 * Search categories from firebase
 * @function
 * @async
 * @deprecated
 *
 * @param query
 * @param limit
 * @param last
 */
export const searchCategories = async (query: string, limit?: number, last?: any): Promise<any> => {
  return [];
  // try {
  //     console.log("Search categories: ", query);

  //     if (!query || query.length < 3) {
  //         return [];
  //     }

  //     if (!limit) {
  //         limit = DB_DEFAULTS.LIMIT;
  //     }

  //     const collectionRef = firebase.firestore().collection(DB_COLLECTIONS.CATEGORIES);
  //     let querySnapshot = null;

  //     // No pagination
  //     if (!last) {
  //         querySnapshot = await collectionRef
  //             .where("keywords", "array-contains", query.toLowerCase())
  //             .orderBy("name", "asc")
  //             .limit(limit)
  //             .get();
  //     } else {
  //         // With pagination
  //         querySnapshot = await collectionRef
  //             .where("keywords", "array-contains", query.toLowerCase())
  //             .orderBy("name", "asc")
  //             .startAfter(last.name)
  //             .limit(limit)
  //             .get();
  //     }

  //     // Impossible but in case...
  //     if (!querySnapshot) {
  //         return [];
  //     }

  //     let data: any[] = [];

  //     querySnapshot.forEach((doc:any) => {
  //         data.push(mapCategory(doc.id, doc.data()));
  //     });

  //     return data;
  // } catch (err) {
  //     console.error(err);
  //     throw new Error(err);
  // }
};

/**
 * Load categories from firebase
 * @function
 * @async
 * @deprecated
 *
 * @param limit
 * @param last
 */
export const getCategories = async (limit?: number, last?: any): Promise<any> => {
  return [];
  // try {
  //     if (!limit) {
  //         limit = DB_DEFAULTS.LIMIT;
  //     }

  //     const collectionRef = firebase.firestore().collection(DB_COLLECTIONS.CATEGORIES);
  //     let querySnapshot = null;

  //     // No pagination
  //     if (!last) {
  //         querySnapshot = await collectionRef.orderBy("name", "asc").limit(limit).get();
  //     } else {
  //         // With pagination
  //         querySnapshot = await collectionRef
  //             .orderBy("name", "asc")
  //             .startAfter(last.name)
  //             .limit(limit)
  //             .get();
  //     }

  //     // Impossible but in case...
  //     if (!querySnapshot) {
  //         return [];
  //     }

  //     let data: any[] = [];

  //     querySnapshot.forEach((doc:any) => {
  //         data.push(mapCategory(doc.id, doc.data()));
  //     });

  //     return data;
  // } catch (err) {
  //     throw new Error(err);
  // }
};

/**
 * Load category from firebase
 * @function
 * @async
 *
 * @param id
 */
export const getCategory = async (id: string): Promise<any> => {
  try {
    let category = await firebase.firestore().collection(DB_COLLECTIONS.CATEGORIES).doc(id).get();

    return category.data();
  } catch (err) {
    throw new Error(err);
  }
};
